import Vue from "vue";
export const state = Vue.observable({
  extra_options: null,
});

export const mutationsMap = {
  setExtraOptions: (extra_options) => {
    state.extra_options = extra_options;
  },
}

export const gettersMap = {
  getExtraOptions: () => { return state.extra_options }
}